<template>
  <KTCodePreview v-bind:title="'Thêm mới nhà cung cấp'">
    <template v-slot:preview>
      <ProviderForm
        ref="providerForm"
        :is-loading="isLoading"
        :is-edit-mode="false"
        :initial-data="defaultProviderData"
      />
    </template>

    <template v-slot:foot>
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <b-button
              tabindex="15"
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="handleSubmit"
              :disabled="isLoading"
            >Lưu</b-button>
            <router-link
              to="/providers"
              tag="button"
            >
              <b-button
                tabindex="16"
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
              >Hủy</b-button>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </KTCodePreview>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ProviderRepository from '@/repositories/ProviderRepository';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import ProviderForm from './shared/components/ProviderForm.vue';

const KTCodePreview = () =>
  import(/* webpackPrefetch: true */ '@/view/content/CodePreview.vue');

const DEFAULT_PROVIDER_DATA_FOR_ADD = {
  name: '',
  phoneNo: '',
  email: '',
  taxNo: '',
  identityCard: '',
  address: '',
  code: '',
  shippingAddress1: '',
  shippingAddress2: '',
  creditLimit: null,
  paymentTermsDays: null,
  type: '2',
  supplierGroupId: null,
  supplierGroupName: '',
  parentId: null,
};

export default {
  name: 'AddProvider',
  components: {
    ProviderForm,
    KTCodePreview,
  },
  data() {
    return {
      isLoading: false,
      defaultProviderData: { ...DEFAULT_PROVIDER_DATA_FOR_ADD },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhà cung cấp', route: '/providers' },
      { title: 'Danh sách nhà cung cấp', route: '/providers' },
      { title: 'Thêm mới nhà cung cấp' },
    ]);
  },
  methods: {
    async handleSubmit() {
      if (this.isLoading) return;
      const formData = this.$refs.providerForm.submit();

      if (formData) {
        this.isLoading = true;
        const payload = {
          ...formData,
          status: 1,
        };

        delete payload.id; // Ensure no id is sent for create operation

        try {
          const response = await ProviderRepository.create(payload);
          makeToastSuccess(response.message || 'Thêm nhà cung cấp thành công!');
          this.$router.push({ name: 'list-provider' });
        } catch (error) {
          console.error('Error creating provider:', error);
          const message =
            error?.response?.data?.message ||
            'Có lỗi xảy ra khi thêm nhà cung cấp.';
          makeToastFaile(message);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 400;
}

.required-control label {
  font-weight: 600;
}
</style>
